import { __assign } from "tslib";
import { DefaultButton, FocusTrapZone, PrimaryButton, } from '@fluentui/react';
import { IconNames } from '@office-start/fabric-icon-subset-utility';
import IconButtonControl from '@office-start/icon-button-control';
import classNames from 'classnames';
import React from 'react';
import styles from './DialogControl.module.scss';
export var DialogControl = function (_a) {
    var _b, _c, _d;
    var actions = _a.actions, closeButtonAriaLabel = _a.closeButtonAriaLabel, content = _a.content, focusTrapProps = _a.focusTrapProps, onClose = _a.onClose, text = _a.text, title = _a.title, useFluentTheme = _a.useFluentTheme;
    var headerBlock = (React.createElement("div", { className: styles['dialog__header'] },
        React.createElement("h2", { className: classNames((_b = {},
                _b[styles['dialog__title']] = !useFluentTheme,
                _b[styles['dialog__title--fluent']] = useFluentTheme,
                _b)) }, title),
        React.createElement("div", { className: classNames(styles['dialog__dismiss']) },
            React.createElement(IconButtonControl, { iconName: IconNames.ChromeClose, onClick: onClose, iconClass: classNames(styles['dialog__dismiss__icon'], 'ms-fcl-bl'), ariaLabel: closeButtonAriaLabel, dataTestId: "dialog-dismiss-button" }))));
    var contentBlock = text ? (React.createElement("div", { className: styles['dialog__text'] }, text)) : content ? (React.createElement("div", { className: styles['dialog__custom-content'] }, content)) : null;
    var actionsBlock = actions ? (React.createElement("div", { className: classNames(styles['dialog__actions'], actions === null || actions === void 0 ? void 0 : actions.containerClassName) }, actions.actions.map(function (action) {
        var _a;
        var ButtonType = action.primary
            ? PrimaryButton
            : DefaultButton;
        return (React.createElement(ButtonType, { "data-testid": action.id, key: action.id, text: action.title, onClick: action.onClick, disabled: action.disabled, className: classNames(action.className, styles['dialog__actions__button'], (_a = {},
                _a[styles['dialog__actions__button--primary']] = action.primary && useFluentTheme,
                _a[styles['dialog__actions__button--default']] = !action.primary && useFluentTheme,
                _a)) }));
    }))) : null;
    return (React.createElement(FocusTrapZone, __assign({}, focusTrapProps),
        React.createElement("div", { className: styles['page-overlay'] },
            React.createElement("div", { className: classNames(styles['page-overlay__background'], (_c = {
                        'ms-bgc-nd': !useFluentTheme
                    },
                    _c[styles['page-overlay__background--fabric']] = !useFluentTheme,
                    _c[styles['page-overlay__background--fluent']] = useFluentTheme,
                    _c)) }),
            React.createElement("div", { className: classNames((_d = {
                        'ms-bgc-w': !useFluentTheme
                    },
                    _d[styles['dialog']] = !useFluentTheme,
                    _d['ms-fcl-np'] = !useFluentTheme,
                    _d[styles['dialog--fluent']] = useFluentTheme,
                    _d)) },
                headerBlock,
                contentBlock,
                actionsBlock))));
};
//# sourceMappingURL=DialogControl.js.map